import type { ReactNode, HTMLProps, ReactElement } from 'react';
import cx from 'clsx';
import {
  IconCheckmarkRoundedFilledSmall,
  IconClockFilledSmall,
  IconErrorFilledSmall,
  IconProcessingFilledSmall,
  IconWarningSignFilledSmall,
  IconCrossRoundedFilledSmall,
} from '@repo/monochrome-icons';
import styles from './status.module.css';

export type StatusType =
  | 'inactive'
  | 'error'
  | 'in-progress'
  | 'validated'
  | 'waiting'
  | 'warning'
  | 'canceled';

export interface StatusProps extends HTMLProps<HTMLSpanElement> {
  level?: StatusType;
  text: ReactNode;
  className?: string;
}

const ICONS = {
  error: <IconErrorFilledSmall />,
  inactive: null,
  'in-progress': <IconProcessingFilledSmall />,
  validated: <IconCheckmarkRoundedFilledSmall />,
  waiting: <IconClockFilledSmall />,
  warning: <IconWarningSignFilledSmall />,
  canceled: <IconCrossRoundedFilledSmall />,
} as const;

export function BadgeStatus({
  level = 'waiting',
  text,
  className,
  ...props
}: StatusProps): ReactElement {
  return (
    <span
      className={cx('caption', styles.status, level === 'inactive' && styles.inactive, className)}
      data-test-badge-status=""
      data-test-level={level}
      {...props}
    >
      {Boolean(ICONS[level]) && (
        <span className={cx(styles.icon, styles[level])}>{ICONS[level]}</span>
      )}
      {text}
    </span>
  );
}
